module.exports = __webpack_public_path__ + "static/media/banner-upload-icon.3a82d41f.svg";